import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Products from './components/Products';
import About from './components/About';
import WhereToBuy from './components/WhereToBuy';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProductDetail from './pages/ProductDetail';

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <Products />
              <About />
              <WhereToBuy />
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/productDetail/:id" element={
            <>
              <ProductDetail />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;